import { useSelector } from 'hooks/useSelector';
import * as React from 'react';
import { Email } from 'screens/AuthDialog/Email';
import { selectAuthStep } from 'store/auth/selectors';
import { AuthenticationSteps } from 'store/auth/types';

import { EmailValidate } from './EmailValidate';
import { Password } from './Password';
import { SetPassword } from './SetPassword';
import { Tfa } from './Tfa';
import { TfaSetup } from './TfaSetup';

export const AuthPageSwitcher: React.FC = () => {
  const authenticationStep = useSelector(selectAuthStep);

  if (authenticationStep === AuthenticationSteps.email) {
    return <Email />;
  }

  if (authenticationStep === AuthenticationSteps.emailvalidate) {
    return <EmailValidate />;
  }

  if (authenticationStep === AuthenticationSteps.password) {
    return <Password />;
  }

  if (authenticationStep === AuthenticationSteps.setpassword) {
    return <SetPassword />;
  }

  if (authenticationStep === AuthenticationSteps.tfaSetup) {
    return <TfaSetup />;
  }

  if (authenticationStep === AuthenticationSteps.tfa) {
    return <Tfa />;
  }

  return null;
};
